const mdm = {
  exportLimit: 500,
  mdmType: {
    depot: 1,
    user: 2,
    material: 3,
    consignee: 4,
    transporter: 5,
    rate_matrix: 6,
    bucc: 7,
    detention: 8,
    loading: 9,
    sla: 10,
    contract_tsd_map: 12,
    extra_drop_off_charge: 13,
    bdr_history: 15,
    location: 16,
    materialcategory: 17,
    blacklist_vehicle: 18,
    blacklist_driver: 19,
    purchase_order: 20,
    vehicle: 22,
    base_fuel_rate: 23,
    driver: 24,
    transportationdbSchema: 25,
    vehicledetail: 26,
    vendor_depots: 27,
    destination_charges: 28,
    cha: 29,
    freightforwarder: 30,
    port: 31,
    package_master: 32,
    MATERIAL_PACKAGE_MAPPING_MASTER_IMPORT: 33,
    activity_time: 34,
    transshipment: 35,
    surge_threshold: 36,
    vehicle_excludes: 37,
    contracttsd: 38,
    share_of_business: 39,
    consignee_additional_details: 40,
    dedicatedtruck: 41,
    source_charge: 42,
    transit_management: 43,
    redirection: 44,
    freight_zone: 45,
    legal_entity: 46,
    material_package_mapping : 47,
    courier_intergration_logs: 48,
  },
};

const delivery_Types = {
  1: 'Shipper Site',
  2: 'Customer Site',
  3: 'Co-Maker Site',
  4: 'Hub',
};

const vehicleUtilizationCheckCategory = {
  NONE: 0,
  WEIGHT: 1,
  VOLUME: 2,
  WEIGHTANDVOLUME: 3,
  WEIGHTORVOLUME: 4,
};

const transportationDbStatus = {
  REMOVE: 1,
  CREATE: 0,
};

const driverStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
};

const status = {
  ACTIVE: 1,
  INACTIVE: 2,
};

const mdmErrorMessage = { // ----> TODO check and change name
  validationErrorMessage: {
    depot: 'Depot not Found',
    vehicle: 'vehicle type not Found',
    specify: 'specify a valid input',

  },
};

const mdmChunkSize = 2000;

// V1 is for JNJ flow
// V2 has same field as modified picklist report
const emailModifiedPicklistFlow = {
  V1: 'V1',
  V2: 'V2',
}

module.exports = {
  mdm,
  delivery_Types,
  vehicleUtilizationCheckCategory,
  transportationDbStatus,
  driverStatus,
  status,
  mdmErrorMessage,
  mdmChunkSize,
  emailModifiedPicklistFlow,
};
